import "../../styles/bootstrap/bootstrap-popover.scss";
import "../../styles/popoverOverride.scss";

import PropTypes from "prop-types";
import React from "react";
import { PopoverBody } from "reactstrap";

import FocusedPopover from "../../components/popover/FocusedPopover";
import { PropTypeShapes } from "../../types";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";

const clickWasCheckbox = e => hasAncestorOfClass(e.target, "formCheckbox");
const clickWasDisclosureArrow = e => hasAncestorOfClass(e.target, "collapseArrow");

class ToolbarPopoverButton extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  toggle() {
    const { popoverOpen } = this.state;
    if (!this.props.disabled) {
      if (!popoverOpen || !this.props.hasChildrenPopoverOpen) {
        this.setState({
          popoverOpen: !popoverOpen
        });
      }
    }
  }

  render() {
    const children = React.Children.toArray(this.props.children);

    const button = React.cloneElement(children[0], {
      onClick: this.toggle
    });
    const buttonId = button.props.id;
    const oldOnClick = children[1].props.onClick;
    const popoverContent = React.cloneElement(children[1], {
      onClick: (e, optionId) => {
        if (!clickWasCheckbox(e) && !clickWasDisclosureArrow(e)) {
          this.toggle();
        }
        if (oldOnClick) {
          oldOnClick(optionId);
        }
      }
    });

    return (
      <div className="toolbarPopoverBtn">
        {button}
        <FocusedPopover
          className={`toolbarPopover ${this.props.popoverClassName ? this.props.popoverClassName : ""}`}
          placement={this.props.placement}
          hideArrow={this.props.hideArrow}
          isOpen={this.state.popoverOpen}
          target={buttonId}
          toggle={this.toggle}
          trigger="legacy"
        >
          <PopoverBody onClick={e => e.stopPropagation()}>{popoverContent}</PopoverBody>
        </FocusedPopover>
      </div>
    );
  }
}

ToolbarPopoverButton.propTypes = {
  placement: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hideArrow: PropTypes.bool,
  children: PropTypeShapes.arrayOfElements.isRequired,
  popoverClassName: PropTypes.string,
  hasChildrenPopoverOpen: PropTypes.bool
};

export default ToolbarPopoverButton;
